<template>
  <InPlayerVideoOverlay>
    <div
      class="animate__animated animate__fadeIn text-white text-center"
      :class="$style.wrapper"
    >
      <div
        class="text-white text-center"
        :class="$style.loadingText"
      >
        {{ $t('loading') }}
        <span style="transform: translateY(12.5%);">
          <span :class="$style.dot">•</span>
          <span :class="$style.dot">•</span>
          <span :class="$style.dot">•</span>
        </span>
      </div>
    </div>
  </InPlayerVideoOverlay>
</template>

<script lang="ts">
import 'animate.css';
import { VideoPlayerOverlayBase } from '../layout/VideoPlayerOverlayBase';
import InPlayerVideoOverlay from '../layout/InPlayerVideoOverlay.vue';
import OverlayContent from '../components/OverlayContent.ts.vue';

export default VideoPlayerOverlayBase.extend({
  i18n: {
    en: {
      loading: 'Loading',
    },
    id: {
      loading: 'Sedang memuat',
    },
    zh: {
      loading: '载入中',
    },
  },
  components: {
    InPlayerVideoOverlay,
    OverlayContent,
  },
});
</script>

<style lang="scss" module>
.wrapper {
  --animate-duration: 6s;
}
.loadingText {
  opacity: 0.75;
}

.dot {
  display: inline-block;
  animation-name: animate;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ease-in-out;

  letter-spacing: 0em;
}
.dot:nth-child(1) { animation-delay: 0.0s; }
.dot:nth-child(2) { animation-delay: 0.5s; }
.dot:nth-child(3) { animation-delay: 1.0s; }
@keyframes animate {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(5%);
  }
}
</style>
